import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Popover from '@mui/material/Popover';
import MenuItem from '@mui/material/MenuItem';

const EventCourseManagerAction = ({ isActive, cancelActive, onCancel, pauseActive, onPause, onUnpause, graceActive, onGrace, onMandateEdit, mandateEditActive,context }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (option, callback) => {
    if (option) {
      callback(context);
    }
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick} aria-controls="options-menu" aria-haspopup="true">
        <MoreVertIcon />
      </IconButton>
      <Popover
        id="options-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {
          isActive && !pauseActive &&
          <MenuItem disabled={pauseActive} onClick={() => handleOptionClick(true, onPause)}>
            Pause
          </MenuItem>
        }


        {
          pauseActive && 
          (
            <MenuItem disabled={!pauseActive} onClick={() => handleOptionClick(pauseActive, onUnpause)}>
              Resume
            </MenuItem>
          )
        }

        <MenuItem disabled={!cancelActive} onClick={() => handleOptionClick(cancelActive, onCancel)}>
          Cancel
        </MenuItem>
        <MenuItem disabled={!graceActive} onClick={() => handleOptionClick(graceActive, onGrace)}>
          Edit Grace Period (advanced)
        </MenuItem>
        <MenuItem disabled={!cancelActive} onClick={() => handleOptionClick(context, onMandateEdit)}>
          Edit
        </MenuItem>
      </Popover>
    </>
  );
};

export default EventCourseManagerAction;
